module Meevo.Components.GlobalNav {
    angular.module("meevo.components.globalNav", []);
}